import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpDeleteExport} from '@/features/exports/http/exports.http'
import {removeExportFromCache} from '@/features/exports/query/exportsCache'
import {errorHandler} from '@/utilities/helpers'

/**
 * Permanently delete a terminal export job (cancelled / failed / archived) and remove it
 * from the history list. Backend rejections are surfaced via the shared error handler.
 */
export const useDeleteExport = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_EXPORT],
        mutationFn: (id: string) => httpDeleteExport(id),
        onSuccess: (_response, id) => {
            removeExportFromCache(queryClient, id)
        },
        onError: errorHandler
    })
}
